// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H_Ro","newExpiryDate":"styles_newExpiryDate__2qqUo","footer":"styles_footer__3PlvT"};